import { format, parseISO } from "date-fns";
import { Log } from "@rumble-it/common-lib/types/models/Log.interface";
import { ColumnsType } from "antd/es/table";
import { Tooltip } from "antd";

const actorTranslations: Record<string, string> = {
  dealership: "Dealer",
  service_partner: "Hersteller",
  driver: "Bestuurder",
  lease_company: "Leasemaatschappij",
  insurance_company: "Verzekeringsmaatschappij",
  rumble_admin: "Admin",
  system: "Systeem",
};

const translateActor = (actor: string | null) => {
  if (!actor) {
    return "Systeem";
  }

  return actorTranslations[actor] ?? actor;
};

export const logColumns = (): ColumnsType<Log> => [
  {
    title: "",
    width: "45px",
    key: "createdBy",
    render: (_: unknown, record: Log) => {
      if (!record.createdBy) {
        return null;
      }
      const initials = record.createdBy?.fullName
        .split(" ")
        .map((word, index, arr) => {
          if (index === 0 || index === arr.length - 1) {
            return word.charAt(0).toUpperCase();
          }

          return "";
        })
        .join("");

      return (
        <Tooltip title={record.createdBy.fullName}>
          <div
            style={{
              backgroundColor: "#f2f2f2",
              display: "inline-flex",
              width: "30px",
              height: "30px",
              fontWeight: 600,
              fontSize: "12px",
              border: "2px solid #e5e5e5",
              color: "#666",
              borderRadius: "50%",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            {initials}
          </div>
        </Tooltip>
      );
    },
  },
  {
    title: "Door",
    dataIndex: "actor",
    key: "actor",
    render: (_: unknown, record: Log) => translateActor(record.actor),
  },
  {
    title: "Type log",
    dataIndex: ["logType", "label"],
    key: "logType",
    render: (_: unknown, record: Log) => record.logType?.label,
  },
  {
    title: "Datum aangemaakt",
    dataIndex: "createdAt",
    key: "createdAt",
    render: (_: unknown, record: Log) =>
      format(parseISO(record.createdAt), "dd-MM-yyyy HH:mm"),
  },
];
